import { useState, type ReactNode, type RefObject } from 'react';
import { ResultsFiltersSheet } from '../../shared/results_page/results_filters_sheet.js';
import {
  RentalResultsFilters,
  type RentalFilterableOffer,
  type RentalFilterCatalog,
  type RentalResultsFiltersCopy,
  type RentalResultsFilterValue,
} from './rental_results_filters.js';

/** Os filtros do carro no palco ESTREITO: a folha de filtros da casca
 *  (`ResultsFiltersSheet`, rascunho + Aplicar) com o painel de cortes do carro
 *  dentro. O `Redefinir` também solta o pino do mapa (#3995), e como o resto
 *  da folha só no `Aplicar`: fechar sem aplicar deixa a lista como estava. */
export function RentalResultsFiltersSheet({
  open,
  onOpenChange,
  returnFocusTo,
  offers,
  catalog,
  currency,
  value,
  copy,
  applyLabel,
  locked,
  countsPartial,
  agencyPinned = false,
  onAgencyUnpin,
  onApply,
}: {
  readonly open: boolean;
  readonly onOpenChange: (open: boolean) => void;
  readonly returnFocusTo: RefObject<HTMLElement | null>;
  readonly offers: readonly RentalFilterableOffer[];
  readonly catalog: RentalFilterCatalog | undefined;
  readonly currency: string;
  readonly value: RentalResultsFilterValue;
  readonly copy: RentalResultsFiltersCopy;
  /** O botão do pé da folha ("Aplicar filtros"). */
  readonly applyLabel: string;
  readonly locked: boolean;
  readonly countsPartial: boolean;
  /** O pino do mapa filtra a lista — ver `RentalResultsFiltersProps`. */
  readonly agencyPinned?: boolean;
  readonly onAgencyUnpin?: () => void;
  readonly onApply: (value: RentalResultsFilterValue) => void;
}): ReactNode {
  // O `Redefinir` do rascunho marca o pino para sair no `Aplicar`; cada
  // abertura começa sem a marca (o mesmo re-semear do rascunho da casca).
  const [unpinOnApply, setUnpinOnApply] = useState(false);
  const [seenOpen, setSeenOpen] = useState(open);
  if (seenOpen !== open) {
    setSeenOpen(open);
    if (open) setUnpinOnApply(false);
  }
  return (
    <ResultsFiltersSheet
      open={open}
      onOpenChange={onOpenChange}
      returnFocusTo={returnFocusTo}
      value={value}
      label={copy.filtersLabel}
      applyLabel={applyLabel}
      locked={locked}
      onApply={(next) => {
        onApply(next);
        if (unpinOnApply) onAgencyUnpin?.();
      }}
    >
      {({ draft, setDraft, close }) => (
        <RentalResultsFilters
          offers={offers}
          {...(catalog ? { catalog } : {})}
          currency={currency}
          value={draft}
          copy={copy}
          locked={locked}
          countsPartial={countsPartial}
          agencyPinned={agencyPinned && !unpinOnApply}
          onAgencyUnpin={() => {
            setUnpinOnApply(true);
          }}
          frame={false}
          dismiss="close"
          onChange={setDraft}
          onCollapse={close}
        />
      )}
    </ResultsFiltersSheet>
  );
}
